import i18next from 'v2/helpers/i18n';
import { currencyConfig } from 'v2/helpers/currency';

// TODO: To check if this affects somehow
const locale = 'en-GB';
const pennyToCurrency = (
  value,
  formatterOpts = currencyConfig[i18next.t('currency')]
) => {
  if (value) {
    // we check if it has decimals. If not, we divide it by 100
    const moneyValue = !value.toString().includes('.')
      ? parseFloat(value / 100)
      : value;
    // we use Intl for parsing the number into currency
    const formatter = new Intl.NumberFormat(locale, formatterOpts);
    return formatter.format(moneyValue);
  }
  return 0;
};

const ONES = [
  '',
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine',
  'ten',
  'eleven',
  'twelve',
  'thirteen',
  'fourteen',
  'fifteen',
  'sixteen',
  'seventeen',
  'eighteen',
  'nineteen',
];
const TENS = [
  '',
  '',
  'twenty',
  'thirty',
  'forty',
  'fifty',
  'sixty',
  'seventy',
  'eighty',
  'ninety',
];

const toWords = (n) => {
  if (n < 20) return ONES[n];
  if (n < 100) {
    return TENS[Math.floor(n / 10)] + (n % 10 ? `-${ONES[n % 10]}` : '');
  }
  if (n < 1000) {
    const rest = n % 100;
    return `${ONES[Math.floor(n / 100)]} hundred${
      rest ? ` and ${toWords(rest)}` : ''
    }`;
  }
  let scale = 1e9;
  if (n < 1e6) scale = 1e3;
  else if (n < 1e9) scale = 1e6;
  const name = { 1000: 'thousand', 1000000: 'million', 1000000000: 'billion' }[
    scale
  ];
  const rest = n % scale;
  const join = rest && rest < 100 ? ' and ' : ' ';
  return `${toWords(Math.floor(n / scale))} ${name}${
    rest ? `${join}${toWords(rest)}` : ''
  }`;
};

const pennyToWords = (value) => {
  if (!value) return '';
  const pennies = !value.toString().includes('.')
    ? parseInt(value, 10)
    : Math.round(parseFloat(value) * 100);
  if (!pennies) return '';
  const pounds = Math.floor(pennies / 100);
  const pence = pennies % 100;
  const text = [
    pounds && `${toWords(pounds)} pound${pounds === 1 ? '' : 's'}`,
    pence && `${toWords(pence)} pence`,
  ]
    .filter(Boolean)
    .join(' and ');
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export default pennyToCurrency;
export { currencyConfig, pennyToWords };
